// Without space search

(function () {
  const KEY = 'nsMap_v1';

  async function getMap() {
    try { const c = sessionStorage.getItem(KEY); if (c) return JSON.parse(c); } catch (e) {}
    const map = {};
    for (let page = 1; page <= 10; page++) {
      const r = await fetch(`/products.json?limit=250&page=${page}`);
      if (!r.ok) break;
      const { products } = await r.json();
      if (!products.length) break;
      products.forEach(p => {
        const w = p.title.toLowerCase().replace(/[^\p{L}\p{N}\s]/gu, ' ').split(/\s+/).filter(Boolean);
        for (let i = 0; i < w.length; i++) {
          for (let n = 2; n <= 3 && i + n <= w.length; n++) {
            const ph = w.slice(i, i + n);
            map[ph.join('')] = ph.join(' ');
          }
        }
      });
    }
    try { sessionStorage.setItem(KEY, JSON.stringify(map)); } catch (e) {}
    return map;
  }

  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('form[action*="/search"]');
    const input = form && form.querySelector('input[name="q"]');
    if (!input) return;

    const q = input.value.trim();
    if (!q || /\s/.test(q)) return; 

    e.preventDefault();
    try {
      const map = await getMap();
      const fixed = map[q.toLowerCase()];
      if (fixed) input.value = fixed;
    } catch (err) {}
    form.submit();
  });
})();

// End Without space search



class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
